import { ACTIONS } from '../actions';
import { pluginKey as typeAheadPluginKey } from '../key';
export var updateQuery = function updateQuery(query) {
  return function (state, dispatch) {
    var pluginState = typeAheadPluginKey.getState(state);
    if ((pluginState === null || pluginState === void 0 ? void 0 : pluginState.query) === query) {
      return false;
    }
    var tr = state.tr;
    tr.setMeta(typeAheadPluginKey, {
      action: ACTIONS.CHANGE_QUERY,
      params: {
        query: query
      }
    });
    if (dispatch) {
      dispatch(tr);
    }
    return true;
  };
};